import React from 'react';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';
import styles from './full-page-loader.module.scss';

export const FullPageLoader: React.FC = () => {
  return (
    <div className={styles.fullPageLoaderContainer}>
      <LoadingSpinner size="big" variant="rectangle" />
    </div>
  );
};
